import { render, staticRenderFns } from "./startexam.vue?vue&type=template&id=74c526cd&"
import script from "./startexam.vue?vue&type=script&lang=js&"
export * from "./startexam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports